import React from 'react';

import { Box, Button, SvgIcon } from '@mui/material';

import API from 'app/API';
import IconEmail from 'app/ui-kit/icons/Download.svg';

import Ai from './components/Ai';
import Cvss2 from './components/Cvss2';
import Cvss3 from './components/Cvss3';
import Epss from './components/Epss';
import useStyles from './styles';

interface Props {
    id: string;
    cvss2?: { cvssV2: Record<string, string | number> };
    cvss3?: { cvssV3: Record<string, string | number> };
    epss?: { epss: number; percentile: number }[];
    aiScore?: { value: number; uncertanity: number };
    showSource?: boolean;
}

const Score: React.FC<Props> = ({ cvss2, cvss3, aiScore, id, epss, showSource = true }) => {
    const { classes } = useStyles();

    return (
        <>
            {cvss3 ? <Cvss3 cvss3={cvss3} /> : null}
            {aiScore ? <Ai aiScore={aiScore} /> : null}
            {cvss2 ? <Cvss2 cvss2={cvss2} /> : null}
            {epss ? <Epss epss={epss} /> : null}
            {showSource ? (
                <Box display="flex" justifyContent="flex-start">
                    <Button
                        fullWidth
                        className={classes.json}
                        variant="outlined"
                        href={`${API.SEARCH_ID.url}?id=${id}`}
                        target="_blank"
                        rel={'nofollow'}
                        startIcon={<SvgIcon component={IconEmail} />}
                    >
                        {'JSON'}
                    </Button>
                </Box>
            ) : null}
        </>
    );
};

export default Score;
